<template>
  <fm-modal title="提交" v-model="modal" width="600px" v-if="modal">
    <fm-form label-align="left">
      <fm-form-item label="职能科室" v-if="updateKeys && updateKeys.split(',').includes('busOrgId')">
        <fm-select absolute filterable :clearable="true" v-model="formData.busOrgId">
          <fm-option v-for="item in orgList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
        </fm-select>
      </fm-form-item>
      <fm-form-item label="科室负责人" v-if="updateKeys && updateKeys.split(',').includes('orgChargeUserId')">
        <fm-select absolute filterable :clearable="true" v-model="formData.orgChargeUserId">
          <fm-option v-for="item in orgChargeUserList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
        </fm-select>
      </fm-form-item>
      <fm-form-item label="分管领导" v-if="updateKeys && updateKeys.split(',').includes('leadUserId')">
        <fm-select absolute filterable :clearable="true" v-model="formData.leadUserId">
          <fm-option v-for="item in leadUserList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
        </fm-select>
      </fm-form-item>
      <fm-form-item label="院长" v-if="updateKeys && updateKeys.split(',').includes('deanUserId')">
        <fm-select absolute filterable :clearable="true" v-model="formData.deanUserId">
          <fm-option v-for="item in deanUserList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
        </fm-select>
      </fm-form-item>
    </fm-form>
    <div class="model-btn">
      <fm-btn style="margin-right: 30px;" @click="formSubmit">提交</fm-btn>
      <fm-btn @click="modal = false">取消</fm-btn>
    </div>
  </fm-modal>
</template>

<script>
export default {
  props: {
    updateKeys: { type: String, defualt: null }
  },
  data () {
    return {
      formData: {},
      modal: false
    }
  },
  computed: {
    repairConfig () {
      let repairConfig = this.$store.getters.sysConfig.repair_config || {}
      return {
        busOrgIdList: repairConfig.busOrgIdList || [],
        deanUserIdList: repairConfig.deanUserIdList || [],
        leadUserIdList: repairConfig.leadUserIdList || [],
        orgChargeUserIdList: repairConfig.orgChargeUserIdList || [],
      }
    },
    orgList () {
      return this.$store.getters.orgList.filter(v => this.repairConfig.busOrgIdList.length === 0 || this.repairConfig.busOrgIdList.includes(v.data.id))
    },
    deanUserList () {
      return this.$store.getters.userList.filter(v => this.repairConfig.deanUserIdList.length === 0 || this.repairConfig.deanUserIdList.includes(v.data.id))
    },
    leadUserList () {
      return this.$store.getters.userList.filter(v => this.repairConfig.leadUserIdList.length === 0 || this.repairConfig.leadUserIdList.includes(v.data.id))
    },
    orgChargeUserList () {
      return this.$store.getters.userList.filter(v => this.repairConfig.orgChargeUserIdList.length === 0 || this.repairConfig.orgChargeUserIdList.includes(v.data.id))
    }
  },
  methods: {
    async formSubmit () {
      let pass = true
      this.updateKeys.split(',').forEach(v => {
        if (!this.formData[v]) {
          pass = false
        }
      })
      if (!pass) {
        this.$notify({
          title: '系统提示',
          message: '请检查表单',
          type: 'info'
        })
      } else {
        this.$emit('submit', this.formData)
        this.modal = false
      }
    }
  }
}
</script>

<style scoped lang="less">
.model-btn {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>